export default function useBadges() {
    /**
     * Return a set of all the badge types represented in the search results.
     */
    const getBadgeTypesInResults = (searchResults) => {
      if (!searchResults) return []
  
      const badgeTypes = new Set()
      const hasBadgeTypes = () => {
        return searchResults.find((r) => r['betterChoiceCategory']) ? true : false
      }
      if (hasBadgeTypes) {
        searchResults.forEach((r) => {
          if (r.betterChoiceCategory) {
            badgeTypes.add(r.betterChoiceCategory)
          }
        })
      }
  
      return Array.from(badgeTypes.values())
    }
  
    return { getBadgeTypesInResults }
  }